import React from 'react';
import Masonry from "react-masonry-css";
import LazyLoad from "react-lazyload";
import Footer from "./Footer";
import './Pricing.css';

const Pricing = () => {
  // Dynamically import all images from the folder
  const importAll = (r) => r.keys().map(r);
  const pricingImages = importAll(
    require.context("../assets/images/pricing", false, /\.(png|jpe?g|svg)$/)
  ).sort((a, b) => a.localeCompare(b)); // Sort by file name
  
  const isSingleImage = pricingImages.length === 1;
  const breakpointColumnsObj = isSingleImage
    ? { default: 1 }
    : {
        default: 3, // 3 columns for large screens
        1100: 2,    // 2 columns for medium screens
        700: 1,     // 1 column for small screens
      };

  return (
    // <div style={{ paddingTop: "140px" }}>
    <div>
      <section id="pricing" className="pricing">
      <Masonry
        breakpointCols={breakpointColumnsObj}
        className={`pricing-masonry${isSingleImage ? " pricing-masonry--single" : ""}`}
        columnClassName="pricing-column"
      >
        {pricingImages.map((image, index) => (
          <div className="pricing-item" key={index}>
            <LazyLoad height={200} offset={100} once>
              <img src={image} alt={`Pricing ${index + 1}`} />
            </LazyLoad>
          </div>
        ))}
      </Masonry>
    </section>
    <Footer />
    </div>
  );
};

export default Pricing;
